import React, {Component} from "react";
import {Control, Field, TextArea} from "bloomer";
import SectionName from "../../../../elements/SectionName";
import FieldDescription from "../../../../elements/FieldDescription";
import InputWarning from "../../../../elements/InputWarning";
import {INVALID_FIELD_STYLE} from "../../../../utils/Constants";
import Spacer from "../../../../elements/Spacer";
import WordsLabel from "../../../../elements/WordsLabel";

interface IAirportCodeExtractorState {
    productDescription: string;
    productDescriptionEmpty: boolean;
    showProductDescriptionLimitWarning: boolean;
    productDescriptionCharactersCount: number;
    seedWords: string;
    seedWordsEmpty: boolean;
    showSeedWordsLimitWarning: boolean;
    seedWordsCharactersCount: number;
}

class ProductNameGenerator extends Component<{}, IAirportCodeExtractorState> {
    public PRODUCT_DESCRIPTION_INPUT_CHARACTERS_LIMIT: number = 1000;
    public SEED_WORDS_INPUT_CHARACTERS_LIMIT: number = 100;

    public constructor(props: {}) {
        super(props);

        this.state = {
            productDescription: "",
            productDescriptionEmpty: false,
            showProductDescriptionLimitWarning: false,
            productDescriptionCharactersCount: 0,
            seedWords: "",
            seedWordsEmpty: false,
            showSeedWordsLimitWarning: false,
            seedWordsCharactersCount: 0
        };
    }

    public handleProductDescriptionChange = (e: any) => {
        const value = e.target.value;
        const charactersCount = value.trim().length;
        this.setState({
            productDescription: value,
            productDescriptionEmpty: false,
            productDescriptionCharactersCount: charactersCount,
            showProductDescriptionLimitWarning: charactersCount > this.PRODUCT_DESCRIPTION_INPUT_CHARACTERS_LIMIT
        });
    };

    public handleSeedWordsChange = (e: any) => {
        const value = e.target.value;
        const charactersCount = value.trim().length;
        this.setState({
            seedWords: value,
            seedWordsEmpty: false,
            seedWordsCharactersCount: charactersCount,
            showSeedWordsLimitWarning: charactersCount > this.SEED_WORDS_INPUT_CHARACTERS_LIMIT
        });
    };

    public resetForm = () => {
        this.setState({
            productDescription: "",
            productDescriptionEmpty: false,
            showProductDescriptionLimitWarning: false,
            productDescriptionCharactersCount: 0,
            seedWords: "",
            seedWordsEmpty: false,
            showSeedWordsLimitWarning: false,
            seedWordsCharactersCount: 0
        });
    };

    public validateForm = () => {
        if (!this.state.productDescription.trim() || this.state.showProductDescriptionLimitWarning
            || !this.state.seedWords.trim() || this.state.showSeedWordsLimitWarning) {
            if (!this.state.productDescription.trim()) {
                this.setState({
                    productDescriptionEmpty: true
                });
            }

            if (!this.state.seedWords.trim()) {
                this.setState({
                    seedWordsEmpty: true
                });
            }

            return false;
        }

        return true;
    };

    public getFormData = () => {
        return {
            product_description: this.state.productDescription.trim(),
            seed_words: this.state.seedWords.trim()
        };
    };

    public render() {
        return <React.Fragment>
            <div>Generates product names from description and example words.</div>
            <Spacer/>
            <Field>
                <Control>
                    <SectionName>Product Description:</SectionName>
                    <FieldDescription>Sample: A pair of shoes that can fit any foot size. Maximum size of input is 1000 characters.</FieldDescription>
                    <TextArea
                        rows={4}
                        className="has-fixed-size"
                        style={(this.state.productDescriptionEmpty || this.state.showProductDescriptionLimitWarning) ? INVALID_FIELD_STYLE : undefined}
                        onChange={this.handleProductDescriptionChange}
                        onPaste={this.handleProductDescriptionChange}
                        value={this.state.productDescription}
                        placeholder={"Enter product description"}
                    />
                    <div>
                        {
                            this.state.productDescriptionEmpty ? <InputWarning>Please input a product description.</InputWarning> : <></>
                        }
                        {
                            this.state.showProductDescriptionLimitWarning ?
                                <InputWarning>Input size limit has been exceeded. Please decrease the size.</InputWarning>
                                : <></>
                        }
                        <WordsLabel>{this.state.productDescriptionCharactersCount}</WordsLabel>
                    </div>
                </Control>
            </Field>
            <Spacer/>
            <Field>
                <Control>
                    <SectionName>Seed Words:</SectionName>
                    <FieldDescription>Enter comma separated words. Sample: adaptable, fit, etc. Maximum size of input is 100 characters.</FieldDescription>
                    <TextArea
                        rows={2}
                        className="has-fixed-size"
                        style={(this.state.seedWordsEmpty || this.state.showSeedWordsLimitWarning) ? INVALID_FIELD_STYLE : undefined}
                        onChange={this.handleSeedWordsChange}
                        onPaste={this.handleSeedWordsChange}
                        value={this.state.seedWords}
                        placeholder={"Enter seed words"}
                    />
                    <div>
                        {
                            this.state.seedWordsEmpty ? <InputWarning>Please input seed words.</InputWarning> : <></>
                        }
                        {
                            this.state.showSeedWordsLimitWarning ?
                                <InputWarning>Input size limit has been exceeded. Please decrease the size.</InputWarning>
                                : <></>
                        }
                        <WordsLabel>{this.state.seedWordsCharactersCount}</WordsLabel>
                    </div>
                </Control>
            </Field>
            <Spacer/>
        </React.Fragment>;
    }
}

export default ProductNameGenerator;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/TextCompletion/templates/ProductNameGenerator.tsx